module.exports = __webpack_public_path__ + "img/main-pic.cdf84e76.png";